<template>
  <div class="Recommend">
     <div class="page-module">
        <header class="index-head">
            <p class="name">
                <template v-if="type == 'host'">热门推荐</template>
                <template v-else>免费报告</template>
            </p>
            <p class="msg">
                <template v-if="type == 'host'"><span v-for="(item,index) in host" :key="index" @click="routeSearch(item.name,item.code, item.code2)">{{item.name}}</span></template>
                <template v-else><span v-for="(item,index) in free" :key="index" @click="routeSearch(item.name,item.code, item.code2, 'free')">{{item.name}}</span></template>
            </p>
            <p class="more" @click="routeSearch()">更多 ></p>
        </header>
        <div class="content">
            <div class="left" @click="routeSearch()">
                <template v-if="type == 'host'"><img src="~common/images/report/index/host.png" alt="host"></template>
                <template v-else><img src="~common/images/report/index/free.png" alt="free"></template>
                
            </div>
            <div class="right">
                <div class="report-card-list">
                    <div v-for="(item,index) in list" :key="index">
                        <div v-if="index < 4" @click="routedetails(item.innerid)"><ReportCard :item="item"></ReportCard></div>
                        <div v-else>
                            <div :class="'report-card-item report-card-item_'+index" @click="routedetails(item.innerid)">
                                <img v-lazy="item.coverurl" :alt="item.subject">
                                <p>{{item.subject}}</p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="clear"></div>
        </div>
     </div>
  </div>
</template>

<script>
import ReportCard from './ReportCard'
export default {
  name: 'Recommend',
  props: ['list', 'type'],
  data () {
    return {
        host: [{name:'创业',code: '03', code2: '0301'},{name:'新能源',code: '02', code2: '0207'},{name:'在线教育',code: '08', code2: '0803'},{name:'低碳节能',code: '13', code2: '1301'},{name:'工业4.0',code: '15', code2: '1502'},{name:'SaaS',code: '21', code2: '2102'},{name:'基础建设',code: '27', code2: '2702'}],
        free: [{name:'信托',code: '01', code2: '0106'},{name:'融资租赁',code: '01', code2: '0109'},{name:'半导体',code: '02', code2: '0203'},{name:'5G',code: '02', code2: '0202'},{name:'新能源',code: '02', code2: '0207'},{name:'天使投资',code: '03', code2: '0302'},{name:'家装家居',code: '09', code2: '0902'},{name:'食品饮料',code: '11', code2: '1103'}]
    }
  },
  mounted () {},
  methods: {
    routedetails(innerid) {
      this.$parent.routerDetails(innerid)
    },
     routeSearch(name,code, code2, status) {
         if (status) {
             this.$router.push({name:"ReportSearch", query:{catecode: code, typeData:code2, title: name, feetype: 1}})
         } else {
             this.$router.push({name:"ReportSearch", query:{catecode: code, typeData:code2, title: name}})
         }
    },
  },
  filters: {},
  watch: {},
  computed: {},
  components: {
      ReportCard
  }
}
</script>
<style lang="scss" type="text/scss" scoped>
.Recommend {
    
    .content {
        margin-top: 10px;
        .left {
            float: left;
            width: 224px;
            height: 357px;
            cursor: pointer;
            img {
                width: 100%;
                height: 100%;
            }
        }
        .right {
            margin-left: 10px;
            float: left;
            width: calc(100% - 234px);

            .two {
                clear: both;
            }
            .report-card-item {
                float: left;
                margin-left: 20px;
                margin-top: 20px;
                width: 425px;
                overflow: hidden;

                &.report-card-item_5,
                &.report-card-item_7,
                &.report-card-item_9 {
                    margin-left: 35px;
                }
               
                img {
                    float: left;
                    width: 18px;
                    height: 18px;
                }
                p { 
                    float: left;
                    margin-left: 6px;
                    line-height: 18px;
                    font-size: 14px;
                    width: calc(100% - 24px);    overflow: hidden;
                    text-overflow: ellipsis;
                    white-space: nowrap;
                    word-break: break-all;
                    cursor: pointer;
                    &:hover {
                        color: #409EFF;
                    }
                }
            }
        }
        .clear {
            clear: both;
        }
    }
}
</style>
